import type { ApprovalStatus } from '../api/types';

export const STATUS_LABEL: Record<ApprovalStatus, string> = {
  Pending: 'Offen',
  Rejected: 'Abgelehnt',
  Executed: 'Ausgeführt',
  Failed: 'Fehlgeschlagen',
};

export const STATUS_COLOR: Record<ApprovalStatus, 'warning' | 'danger' | 'success'> = {
  Pending: 'warning',
  Rejected: 'danger',
  Executed: 'success',
  Failed: 'danger',
};
